var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntune(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M0 19.344C0 2.996 21.376-5.953 35.498 4.482l30.7 22.67 25.907-14.681c13.693-7.467 35.635-2.111 35.895 18.3v75.22c0 16.348-20.749 24.871-34.87 14.435L61.87 97.26l-25.938 14.685C22.11 119.483.022 113.7.022 93.835.022 69.992 0 79.147 0 19.346Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M0 19.344C0 2.996 21.376-5.953 35.498 4.482l30.7 22.67 25.907-14.681c13.693-7.467 35.635-2.111 35.895 18.3v75.22c0 16.348-20.749 24.871-34.87 14.435L61.87 97.26l-25.938 14.685C22.11 119.483.022 113.7.022 93.835.022 69.992 0 79.147 0 19.346Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M0 19.344C0 2.996 21.376-5.953 35.498 4.482l30.7 22.67 25.907-14.681c13.693-7.467 35.635-2.111 35.895 18.3v75.22c0 16.348-20.749 24.871-34.87 14.435L61.87 97.26l-25.938 14.685C22.11 119.483.022 113.7.022 93.835.022 69.992 0 79.147 0 19.346Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M35.498 4.482C21.376-5.953 0 2.996 0 19.344V92.91c0-1.788.911-5.349.911-5.349 4.212-13.768 22.117-18.93 34.505-9.857l57.713 42.723C107.251 130.862 128 122.339 128 105.991v-75.22c0 13.965-18.254 27.984-35.498 15.837L35.498 4.482Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    fillOpacity: 0.25,
    d: "M35.498 4.482C21.376-5.953 0 2.996 0 19.344V92.91c0-1.788.911-5.349.911-5.349 4.212-13.768 22.117-18.93 34.505-9.857l57.713 42.723C107.251 130.862 128 122.339 128 105.991v-75.22c0 13.965-18.254 27.984-35.498 15.837L35.498 4.482Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    fillOpacity: 0.55,
    d: "M35.498 4.482C21.376-5.953 0 2.996 0 19.344V92.91c0-1.788.911-5.349.911-5.349 4.212-13.768 22.117-18.93 34.505-9.857l57.713 42.723C107.251 130.862 128 122.339 128 105.991v-75.22c0 13.965-18.254 27.984-35.498 15.837L35.498 4.482Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M35.498 46.173C21.376 35.737 0 44.687 0 61.035v-41.69C0 2.995 21.376-5.954 35.498 4.481l57.004 42.126C109.746 58.755 128 44.736 128 30.771v42.666c0 16.348-21.376 25.297-35.498 14.862L35.498 46.173Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    fillOpacity: 0.36,
    d: "M35.498 46.173C21.376 35.737 0 44.687 0 61.035v-41.69C0 2.995 21.376-5.954 35.498 4.481l57.004 42.126C109.746 58.755 128 44.736 128 30.771v42.666c0 16.348-21.376 25.297-35.498 14.862L35.498 46.173Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-32.32877 87.75358 -65.73449 -24.21685 114.551 -17.314)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.423,
    stopColor: "#004AFF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729,
    stopColor: "#014DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836,
    stopColor: "#014DB9",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    stopColor: "#014DB9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(20.96754 -71.4404 87.0233 25.54107 17.087 121.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.091,
    stopColor: "#004AFF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#014DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.749,
    stopColor: "#014DB9",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#014DB9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-125.5162 129.6675 -99.87357 -96.67611 140.403 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#23C0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#23C0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#1C91FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(89.83163 92.72884 -22.05946 21.37024 38.168 10.147)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.165,
    stopColor: "#096DD6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#096DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901,
    stopColor: "#0876DE",
    stopOpacity: 0.814
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#029AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(91.61 24.338 98.247) scale(20.7357 18.6738)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0068B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#006CB8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(69.461 10.735 15.486) scale(31.8924 25.7596)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCF9FF",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35DDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 54.661,
    x2: 100.343,
    y1: 125,
    y2: 27.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#1169DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#0151BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614,
    stopColor: "#014DB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#126AD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 36.491,
    x2: 58.042,
    y1: 29.479,
    y2: 121.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92EEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565,
    stopColor: "#35DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08B1F9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h128v128H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntune);
export default __webpack_public_path__ + "static/media/intune.aec1839d91ef67c1d72c7ee0eae6fbfd.svg";
export { ForwardRef as ReactComponent };